// extracted by mini-css-extract-plugin
export default {"image-row":"PolaroidStyleItemListView__image-row___PcJ0P","image-wrapper":"PolaroidStyleItemListView__image-wrapper___cTAoh"};